import { MoreVertical, PenLine, Trash2 } from "lucide-react";

import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { CreateNavItemFormDialog } from "../layout/Sidebar/forms/CreateNavItemFormDialog";
import { type RawNavItem } from "../layout/Sidebar/utils/NavItems";
import { useSidebarItems } from "@/context/SideBarItemsProvider";

export function ShortcutActions({ item }: { item: RawNavItem }) {
  const { sidebarItems, setSidebarItems } = useSidebarItems();
  const node = sidebarItems.find((candidate) => candidate.id === item.id);

  if (!node) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1 h-7 w-7 text-muted-foreground"
          onClick={(e) => e.stopPropagation()}
          aria-label={`Actions for ${item.name}`}
          data-testid={`shortcut-menu-${item.id}`}
        >
          <MoreVertical size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[200px]">
        <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
          <CreateNavItemFormDialog
            parentId={item.parent ?? 0}
            navItem={node}
            trigger={(
              <button className="flex w-full items-center" data-testid={`shortcut-edit-${item.id}`}>
                <PenLine size={16} className="mr-2" />
                <span>Edit shortcut</span>
              </button>
            )}
          />
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => setSidebarItems(sidebarItems.filter((candidate) => candidate.id !== item.id))}
          className="text-red-600 focus:text-red-600"
          data-testid={`shortcut-delete-${item.id}`}
        >
          <Trash2 size={16} className="mr-2" />
          Delete shortcut
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
